import { createSlice } from "@reduxjs/toolkit";
import { geteceactivityskillThunk, getmastereceactivitiydetailsThunk, createmastereceactivitiesThunk, updatemastereceactivitiesThunk } from "./EceActivity.Thunk";

const initialState = {
  data: [],
  skills: [],
  loading: false,
  status: "",
  message: "",
  preferedlanguage: "",
  clas: "",
  usertype: "",
   skill: "",
  disable_content_button: true,
};

const EceActivitySlice = createSlice({
  name: "eceactivityslice",
  initialState,
  reducers: {
    preferedlanguage_change: (state, action) => {
      state.preferedlanguage = action.payload;
      state.data = [];
      state.clas = "";
      state.usertype = "";
      state.skill = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.clas = "";
      state.skill = "";
      state.disable_content_button = true;
    },
    class_change: (state, action) => {
      state.clas = action.payload;
      state.data = [];
      state.skill = "";
      state.disable_content_button = true;
    },
    skill_change: (state, action) => {
      state.skill = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
  },
  extraReducers: {
    [geteceactivityskillThunk.pending]: (state, action) => {
      state.skills = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [geteceactivityskillThunk.fulfilled]: (state, action) => {
      state.skills = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Ece Content success";
    },
    [geteceactivityskillThunk.rejected]: (state, action) => {
      state.skills = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [getmastereceactivitiydetailsThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getmastereceactivitiydetailsThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [getmastereceactivitiydetailsThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createmastereceactivitiesThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createmastereceactivitiesThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createmastereceactivitiesThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updatemastereceactivitiesThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updatemastereceactivitiesThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updatemastereceactivitiesThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { preferedlanguage_change, class_change, usertype_change, skill_change } = EceActivitySlice.actions;

export default EceActivitySlice.reducer;
